import { useEffect } from 'react';

/**
 * Cache em memória das telas, para voltar a um menu sem esperar: a tela mostra o
 * que tinha da última visita e busca de novo por trás. Some ao recarregar a
 * página e quando muda quem está logado (ver AuthContext). As chaves devem
 * incluir a organização ou o projeto.
 */
const cache = new Map<string, unknown>();

export function readScreenCache<T>(key: string): T | undefined {
  return cache.get(key) as T | undefined;
}

export function writeScreenCache<T>(key: string, value: T) {
  cache.set(key, value);
}

export function clearScreenCache() {
  cache.clear();
}

/** Mantém o cache igual ao estado da tela, inclusive depois de edições locais. */
export function useScreenCacheSync<T>(key: string | null, value: T, ready: boolean) {
  useEffect(() => {
    if (key && ready) writeScreenCache(key, value);
  }, [key, value, ready]);
}
